import React, { useState, useEffect } from "react";
// import Ampli from "../../assets/equipment/ampli.webp";
import Accordion from "react-bootstrap/Accordion";
import randall from "../../assets/equipment/randallforsite.webp";
import ebs from "../../assets/equipment/ebsforsite.webp";
import kustom_hv100 from "../../assets/equipment/kustom_hv100.webp";
import tama_imperial_star from "../../assets/equipment/tamaforsite.webp";
import a_custom_cymbal_pack from "../../assets/equipment/acustomforsite.webp";
import istanbul_mehmet_imc from "../../assets/equipment/istanbulMehmetForSite.webp";
import dynacord_d_15_3 from "../../assets/equipment/dynacordForSite.webp";
import soundking_sk from "../../assets/equipment/soundkingforsite.webp";
import dynacord_sl1800 from "../../assets/equipment/dynacordampforsite.webp";
import apollox8p from "../../assets/equipment/apolloforsite.webp";
import fourseventen from "../../assets/equipment/4-710forsite.webp";
import ksm from "../../assets/equipment/ksmforsite.webp";
import sm from "../../assets/equipment/shuresmforsite.webp";
import sm57 from "../../assets/equipment/shuresm57forsite.webp";
import beta52 from "../../assets/equipment/beta52forsite.webp";
import beta91 from "../../assets/equipment/beta91forsite.webp";
import senheiser from "../../assets/equipment/senheizerforsite.webp";
import beta58 from "../../assets/equipment/beta58forsite.webp";
import logic from "../../assets/equipment/logic.webp";
import jdi from "../../assets/equipment/jdiforsite.webp";
import dt770 from "../../assets/equipment/dt770forsite.webp";
import dt880 from "../../assets/equipment/dt880forsite.webp";
import art from "../../assets/equipment/artforsite.webp";
import yamaha from "../../assets/equipment/yamahaforsite.webp";
import xr18 from "../../assets/equipment/xr18forsite.webp";
import hs5 from "../../assets/equipment/hs5forsite.webp";
import realverb from "../../assets/equipment/07forsite.webp";
import c1176limiter from "../../assets/equipment/1176forsite.webp";
import fairchild from "../../assets/equipment/fairchildforsite.webp";
import helios from "../../assets/equipment/heliostype69forsite.webp";
import la from "../../assets/equipment/la-la3forsite.webp";
import plexi from "../../assets/equipment/marshallplexiforsite.webp";
import precision from "../../assets/equipment/precisionmixforsite.webp";
import pulltec from "../../assets/equipment/pulltecforsite.webp";
import pureplate from "../../assets/equipment/pureplateforsite.webp";
import lala from "../../assets/equipment/teletronixforsite.webp";
import ua610 from "../../assets/equipment/ua610forsite.webp";
import v76 from "../../assets/equipment/v76forsite.webp";
import { useTranslation } from "react-i18next";

const accordionData = [
  {
    eventKey: "0",
    header: "Sound",
    body: [
      { name: "Bass amp EBS Classic 500", img: ebs },
      { name: "Electric guitar amp Randall RX120D", img: randall },
      { name: "Electric guitar amp Kustom HV100", img: kustom_hv100 },
      { name: "Acoustic drumkit TAMA imperial star", img: tama_imperial_star },
      { name: "Cymbals Zildjian A-Custom", img: a_custom_cymbal_pack },
      { name: "Cymbals Istanbul Mehmet IMC", img: istanbul_mehmet_imc },
      { name: "Mixer Behringer X Air XR18", img: xr18 },
      { name: "Speakers Dynacord D 15-3", img: dynacord_d_15_3 },
      { name: "Speakers Soundking", img: soundking_sk },
      { name: "Power amp Dynacord SL 1800", img: dynacord_sl1800 },
      { name: "Direct-Box Rarial JDI", img: jdi },
      { name: "Headphones beyerdynamic DT-770 Pro", img: dt770 },
      { name: "Headphones beyerdynamic DT-880 Pro", img: dt880 },
      { name: "Keyboard Yamaha PSR-450", img: yamaha },
      { name: "Headphone amp ART Headamp 6 Pro", img: art },
    ],
  },
  {
    eventKey: "1",
    header: "Recording",
    body: [
      { name: "Audio interface UA Apollo x8p", img: apollox8p },
      { name: "Preamp UA 4-710D", img: fourseventen },
      { name: "Condenser mic Shure KSM 137", img: ksm },
      { name: "Large diaphragm mic Shure SM 7 B", img: sm },
      { name: "Instrument mic Shure SM57", img: sm57 },
      { name: "Instrument mic Shure Beta 52", img: beta52 },
      { name: "Instrument mic Shure Beta 91", img: beta91 },
      { name: "Instrument mic Senheiser E604", img: senheiser },
      { name: "Vocal mic Shure Beta 58 A", img: beta58 },
      { name: "DAW Logic Pro X", img: logic },
      { name: "Monitors Yamaha HS 5", img: hs5 },
    ],
  },
  {
    eventKey: "2",
    header: "Plug-In Library from Universal Audio",
    body: [
      { name: "RealVerb 5.1", img: realverb },
      { name: "1176 Classic Limiter", img: c1176limiter },
      { name: "Fairchild Tube Limiter", img: fairchild },
      { name: "Helios Type 69 Preamp", img: helios },
      { name: "Teletronix LA‑3A compressor", img: la },
      { name: "Marshall Plexi Super Lead 1959", img: plexi },
      { name: "Precision Maximizer", img: precision },
      { name: "Pultec Passive EQ", img: pulltec },
      { name: "Pure Plate Reverb", img: pureplate },
      { name: "Teletronix LA-2A Leveling Amplifiers", img: lala },
      { name: "610 Preamplifier", img: ua610 },
      { name: "V76 Preamplifier ", img: v76 },
    ],
  },
];

const Equipment = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(ebs);
  const [itemName, setItemName] = useState("Bass amp EBS Classic 500");

  useEffect(() => {
    const allImages = accordionData.flatMap((section) =>
      section.body.map((item) => item.img)
    );
    allImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);
  const handleImageChange = (item) => {
    setSelectedImage(item.img);
    setItemName(item.name);
  };
  return (
    <div className="Equipment-section" id="Equipment">
      <h1> {t("Equipment")}</h1>
      <div className="d-flex justify-content-between equipment-section-wrapper">
        <div className="equipment-left-part">
          <div className="equipment-left-part-img  ">
            <img src={selectedImage} alt="" />
          </div>
          <p className="">{t(itemName)}</p>
        </div>

        <div className="equipment-right-part-content">
          <Accordion defaultActiveKey="0" flush>
            {accordionData.map((section) => (
              <Accordion.Item
                eventKey={section.eventKey}
                key={section.eventKey}
              >
                <Accordion.Header>{t(section.header)}</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    {section.body.map((item, index) => (
                      <li
                        key={index}
                        onClick={() => handleImageChange(item)}
                      >
                        {t(item.name)}
                      </li>
                    ))}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default Equipment;
